import React, {
  CSSProperties,
  forwardRef,
  ReactNode,
  SyntheticEvent,
} from 'react';
import styled from 'styled-components';
import { ReactComponent as CheckIcon } from '../../assets/check-fill.svg';
import colors from '../../constants/colors.constants';

export interface CheckboxProps {
  value?: string;
  onChange?: (checked: boolean, event: SyntheticEvent) => void;
  style?: CSSProperties;
  label?: string | ReactNode;
  id: string;
  checked?: boolean;
  borderless?: boolean;
}
const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const { borderless = false, checked, id, label, style, onChange } = props;

  return (
    <div
      className="flex items-start"
      style={{
        cursor: 'pointer',
        position: 'relative',
      }}
    >
      <StyledCheckbox
        $primary1={colors.primary3}
        $borderless={borderless}
        checked={checked || false}
        id={id}
        name={id}
        type="checkbox"
        style={style}
        ref={ref}
        onChange={(e) => {
          const { target } = e;
          const { checked } = target;
          if (onChange) {
            onChange(checked, e);
          }
        }}
      />
      <label
        htmlFor={id}
        style={{
          cursor: 'pointer',
        }}
      >
        {label}
      </label>
      <CheckIcon
        style={{
          position: 'absolute',
          color: checked ? 'white' : '#BEBEBE',
        }}
      />
    </div>
  );
});

export default Checkbox;

const StyledCheckbox = styled.input<{
  $borderless: boolean;
  $primary1: string;
}>`
  border-radius: 6px;
  appearance: none;
  width: 24px;
  height: 24px;
  border: ${(props) => {
    if (props.$borderless) return 'none';
    return `1px solid ${colors.defaultBorder};`;
  }};
  background-color: white;
  cursor: pointer;
  background-size: 100% 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  flex-shrink: 0;

  &:checked {
    background-color: ${(props) => props.$primary1};
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;

    border: none;
  }
  transition: all 0.2s;
`;
